<!--<template>-->
<!--    <div class="motor-reselect">-->
<!--        <button class="btn" style="width: 100%;" @click="showModal = true">{{ buttonName }}</button>-->
<!--        <motor-select-modal v-if="showModal" @close="showModal = false"></motor-select-modal>-->
<!--    </div>-->
<!--</template>-->

<template>
    <select class="form-control" v-model="activeMotor">
        <option v-for="(motor) in motors" :key="motor.id" :value="motor.id">{{ motor.type }} {{ motor.title }}</option>
    </select>
</template>

<script>
  import {mapState} from 'vuex';

  export default {
    name: 'MotorReselect',

    data() {
      return {
        showModal: false
      }
    },
    components: {

    },
    computed: {
      ...mapState({
        selectedMotor: state => state.preference.selectedMotor,
        motors: state => state.motors.all,
      }),
      activeMotor: {
        get() {
          return this.selectedMotor;
        },
        set(val) {
          this.$store.dispatch('build/selectMotor', val)
        }
      }
    }
  }
</script>
